import { forwardRef } from 'react'
import {
  UserMenu as RaUserMenu,
  Logout,
  Link,
  useTranslate,
  useUserMenu,
} from 'react-admin'
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import IconAccountSettings from '@mui/icons-material/AccountCircle'
import { capitalize } from '../../util'

const AccountMenuItem = forwardRef((props, ref) => {
  const { onClose } = useUserMenu()
  const translate = useTranslate()
  return (
    <MenuItem
      onClick={onClose}
      ref={ref}
      {...props}
    >
      <Link to='/account_settings' color='inherit' underline='none' sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <ListItemIcon>
        <IconAccountSettings fontSize='small' />
      </ListItemIcon>
      <ListItemText>{capitalize(translate(`resources.users.name`, { smart_count: 1 }))}</ListItemText>
      </Link>
    </MenuItem>
  )
})

const UserMenu = props => {
  return (
    <RaUserMenu
      {...props}
    >
      <AccountMenuItem />
      <Logout />
    </RaUserMenu>
  )
}

export default UserMenu
